import { useState } from "react";
import { toast } from "sonner";
import { Activity, Save, Loader2 } from "lucide-react";
import { api, apiErr } from "../api";
import { FOLLOWUP_GROUPS } from "../fields";
import { Modal, todayISO } from "../ui";

/** Nueva actualización / seguimiento: mismos campos clínicos para comparar la evolución. */
export default function FollowUpModal({ patient, onClose, onSaved }) {
  const [form, setForm] = useState({ fecha: todayISO(), nota: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/patients/${patient.id}/updates`, form);
      toast.success("Seguimiento guardado");
      onSaved && onSaved();
      onClose();
    } catch (e) { toast.error(apiErr(e, "No se pudo guardar")); }
    finally { setBusy(false); }
  };

  return (
    <Modal title="Nueva actualización / seguimiento" subtitle={patient?.nombre} icon={Activity} onClose={onClose} maxWidth="max-w-3xl"
      footer={<>
        <button onClick={onClose} className="pn-btn pn-btn-ghost">Cancelar</button>
        <button onClick={submit} disabled={busy} className="pn-btn pn-btn-primary">{busy ? <Loader2 size={16} className="pn-spin" /> : <Save size={16} />} Guardar seguimiento</button>
      </>}>
      <div className="space-y-6">
        <div className="grid sm:grid-cols-2 gap-4">
          <div><label className="pn-label">Fecha de esta consulta</label><input type="date" value={form.fecha} onChange={set("fecha")} className="pn-field" /></div>
          <div><label className="pn-label">Resumen (opcional)</label><input value={form.nota} onChange={set("nota")} placeholder="Ej. Control a los 3 meses" className="pn-field" /></div>
        </div>
        <p className="text-xs pn-muted -mt-3">Llena solo lo que cambió. Lo vacío se muestra como “—” en la comparación.</p>
        {FOLLOWUP_GROUPS.map((g) => (
          <div key={g.group}>
            <h4 className="font-bold pn-ink mb-3">{g.group}</h4>
            <div className="grid sm:grid-cols-2 gap-3">
              {g.items.map(([k, label]) => (
                <div key={k}><label className="pn-label">{label}</label>
                  <textarea rows={2} value={form[k] || ""} onChange={set(k)} placeholder={patient?.[k] ? `Antes: ${String(patient[k]).slice(0, 60)}` : ""} className="pn-field resize-y" /></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
}
